/** Hide slab placeholder glass while dynamic glazing is painted on top. */
export function hideAuthoredGlassSlots(markup: string): string {
  const document = new DOMParser().parseFromString(
    `<svg xmlns="http://www.w3.org/2000/svg">${markup}</svg>`,
    'image/svg+xml'
  );
  if (document.querySelector('parsererror')) return markup;

  document.querySelectorAll('.glass-slot, [data-colour-role="glass"]').forEach((element) => {
    element.setAttribute('fill', 'none');
    element.setAttribute('stroke', 'none');
    element.setAttribute('opacity', '0');
  });

  return Array.from(document.documentElement.childNodes)
    .filter((node) => node.nodeType === 1)
    .map((node) => (node as Element).outerHTML)
    .join('');
}
